export const ListingStatusFilters = {
  ALL: 'All',
  SOLD: 'Sold',
  UNSOLD: 'Unsold',
};

// Barcode character length is limited by physical scanners' resolution capabilities.
// Keep in sync with the equivalent const in server/ with the same name.
export const LISTING_BARCODE_CHAR_LENGTH = 17;
